import type { ChunkLookupSpan } from './query'

/** True when the span's feature media is licensed (non–Gaia-original). */
export function spanIsLicensed (span: ChunkLookupSpan): boolean {
  return span.featureMedia?.isGaiaOriginal === false
}

export function resultsIncludeLicensedSpans (spans: ChunkLookupSpan[]): boolean {
  return spans.some(spanIsLicensed)
}
